import React from 'react'
import './SectionHero.scss'

const sectionHero = ({ className, pretitle, title, subtitle, imageSrc, imageAlt, children }) => {
  return (
    <div className={`${className} section-hero`}>
      { pretitle && <h3 className="pretitle header-h6">{ pretitle }</h3> }
      { title && <h1 className="header-h1">{ title }</h1> }
      { subtitle && <p className="body-01-01">{ subtitle }</p> }
      { imageSrc && <img src={imageSrc} alt={imageAlt} /> }
      { children }
    </div>
  )
}

export default sectionHero
